import { EnvironmentProviders, Provider } from '@angular/core';
import { AppConfig } from '../config/app-config.token';
import { runtimeConfig } from '../config/runtime-config';
import { AUTH_PORT, AuthPort } from './auth-port';
import { SesionCookieAuth } from './sesion-cookie-auth';
import { SimuladaAuth } from './simulada-auth';

export function crearAuthPort(auth: AppConfig['auth'], apiBaseUrl: string): AuthPort {
  if (auth.modo === 'entra') {
    return new SesionCookieAuth(apiBaseUrl);
  }

  return new SimuladaAuth();
}

/**
 * FE-86: el backend resuelve Entra ID; la consola no necesita un arranque especial (ni
 * `handleRedirectPromise` ni nada de MSAL). El contexto de acceso (`GET /v1/accesos/contexto`)
 * que ya se consulta al iniciar decide: 200 renderiza, 401 lo redirige `entraAuthInterceptor`.
 */
export function provideAuth(): (Provider | EnvironmentProviders)[] {
  return [{ provide: AUTH_PORT, useFactory: () => crearAuthPort(runtimeConfig.auth, runtimeConfig.apiBaseUrl) }];
}
